import {
  createSummaryCardsConfig,
  createDataGridConfig,
} from '../email-pulse-config-defaults';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';

/**
 * Configuration for Messages tab summary cards
 */
export const messagesSummaryCardsConfig = createSummaryCardsConfig(
  'marketingSummary',
  'MessagesSummaryCards',
);

/**
 * Configuration for Messages tab data grid
 */
const messagesGrid = createDataGridConfig(
  'messageTitle',
  EMAIL_PULSE_DEFINITIONS.messageTitle,
);
export const getMessagesDataGridColumns = messagesGrid.getColumns;
export const messagesColumnVisibilityModel = messagesGrid.columnVisibilityModel;
